import React from 'react';
import Icon from '../../../components/AppIcon';

const ProductionSchedulePanel = ({ cases }) => {
  const upcomingCases = cases
    ?.filter(c => c?.status === 'assigned' || c?.status === 'in_progress')
    ?.sort((a, b) => new Date(a?.assignedAt) - new Date(b?.assignedAt))
    ?.slice(0, 5);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'assigned':
        return 'Clock';
      case 'in_progress':
        return 'Activity';
      case 'completed':
        return 'CheckCircle';
      default:
        return 'Circle';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'assigned':
        return 'text-blue-600';
      case 'in_progress':
        return 'text-yellow-600';
      case 'completed':
        return 'text-green-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Planning Production</h2>
        <p className="text-sm text-gray-600 mt-1">Cas à traiter prochainement</p>
      </div>
      <div className="p-6">
        {upcomingCases?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Calendar" size={48} className="text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Aucune conception en attente</p>
          </div>
        ) : (
          <div className="space-y-3">
            {upcomingCases?.map(caseItem => (
              <div key={caseItem?.id} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
                <Icon
                  name={getStatusIcon(caseItem?.status)}
                  size={20}
                  className={getStatusColor(caseItem?.status)}
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    Cas #{caseItem?.caseId?.slice(0, 8)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {new Date(caseItem?.assignedAt)?.toLocaleDateString('fr-FR')}
                  </p>
                  {caseItem?.machine && (
                    <p className="text-xs text-gray-600 mt-1">
                      {caseItem?.machine?.machine_name}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductionSchedulePanel;